import React from "react";
import { RaisedButton } from "material-ui";
import connectToStores from "alt-utils/lib/connectToStores";

@connectToStores
class ResetCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  static getStores() {
    return [];
  }

  static getPropsFromStores() {
    return {};
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    appSettings: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

 
  render() {
    const { 
      enable_cart
    } = this.context.appSettings;

    let { style, label, resetCart } = this.props;

    let button = (
      <RaisedButton
        className="eventive__reset-cart-button__button"
        label={label || "Reset Cart"}
        labelPosition="before"
        primary={true}
        onClick={() => { resetCart(); }}
      >
      </RaisedButton>
    );

    // EE informational error message
    if (!enable_cart) {
      console.log("Eventive Everywhere Reset Cart Button: Render failed - cart is not enabled for this event bucket");
    }

    return (
      <div
        className="eventive__reset-cart-button__container"
      >
        {enable_cart ? button : null}
      </div>
    );
  }
}

export default ResetCartButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/reset-cart-button.jsx